<template>
  <div class="mx-10 ma-5">
    <TimeFrameButtons
      :title="''"
      :time-frames="[
        'resource utilization table',
        'past projects performance',
        'projects overview',
      ]"
      :active-time-frame="this.activePeriod"
      @change-time-frame="filterData"
    />
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card class="my-card3" v-if="utili">
      <div>
        <v-row>
          <v-col cols="5" md="5" sm="6">
            <DatePicker
              :lable="'Start Date'"
              v-model="form.start_date"
              :setectVale="form.start_date"
              offset-y
              @changeInput="form.start_date = $event"
            >
            </DatePicker>
          </v-col>
          <v-col cols="5" md="5" sm="6">
            <DatePicker
              :lable="'Due Date'"
              v-model="form.due_date"
              :setectVale="form.due_date"
              offset-y
              @changeInput="form.due_date = $event"
            >
            </DatePicker>
          </v-col>
          <v-col cols="2" md="2" sm="6">
            <v-btn
              large
              color="#00B3FF"
              :loading="loading"
              dark
              depressed
              block
              @click="submit()"
              >Search</v-btn
            >
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-card class="pa-5" v-if="utili">
      <div>
        <v-data-table
          v-if="employers"
          :headers="headers"
          :items="employers"
          :items-per-page="5"
          :hide-default-footer="true"
          :disable-sort="true"
          :disable-pagination="true"
          id="data-table"
        >
          <template v-slot:item="{ item, index }">
            <tr
              :class="[
                { 'first-row': index === 0 },
                index % 2 === 0 ? 'dark-row' : 'light-row',
                'custom-row',
              ]"
            >
              <td>
                <v-avatar size="36px">
                  <img
                    v-if="item.profile_image"
                    :src="item.profile_image"
                    style="width: 100%; height: 100%;"
                  />
                  <img
                    v-else
                    :src="defaultImage"
                    style="width: 100%; height: 100%;"
                  />
                </v-avatar>
              </td>
              <td class="text-center">{{ item.name }}</td>
              <td class="text-center">{{ item.employer.specialty }}</td>
              <td class="text-center">{{ item.allocated_hours }}</td>
              <td class="text-center">{{ item.completed_hours }}</td>
              <td class="text-center">{{ item.due_hours }}</td>
              <td class="text-center">{{ item.working_hours }}</td>
              <td class="text-center">
                <v-chip :color="getChipColor(item.freeDays)" dark>
                  {{ item.freeDays }}%
                </v-chip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <Pagination
        @previous="page--"
        @next="page++"
        :loading="loading"
        :total="total"
        :page="page"
        class="mt-5"
      ></Pagination>
    </v-card>

    <v-card class="pa-5" v-if="past">
      <div>
        <PageTitleWithSearch
          :title="'Completed Projects'"
          :loading="loading"
          :search="search"
          @searchText="searchChange($event)"
        >
        </PageTitleWithSearch>
        <v-data-table
          v-if="completed_projects"
          :headers="formattedHeadersPast"
          :items="completed_projects"
          :items-per-page="5"
          :hide-default-footer="true"
          :disable-sort="true"
          :disable-pagination="true"
          id="data-table"
        >
          <template v-slot:item="{ item, index }">
            <tr
              :class="[
                { 'first-row': index === 0 },
                index % 2 === 0 ? 'dark-row' : 'light-row',
                'custom-row',
              ]"
            >
              <td>{{ item.project_name }}</td>
              <td v-if="item.project_type" class="text-center">
                {{ item.project_type.name }}
              </td>
              <td v-else class="text-center">{{ "" }}</td>
              <td class="text-center">{{ item.bsa }}</td>
              <td class="text-center">{{ item.budget }}</td>
              <td class="text-center">{{ item.start_date }}</td>
              <td class="text-center">{{ item.estimated_hours }}</td>
              <td class="text-center">{{ item.actual_hours }}</td>
              <td class="text-center">{{ item.due_date }}</td>
              <td class="text-center">{{ item.completed_date }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <Pagination
        @previous="page--"
        @next="page++"
        :loading="loading"
        :total="total"
        :page="page"
        class="mt-5"
      ></Pagination>
    </v-card>

    <v-card class="pa-5" v-if="presen">
      <div>
        <PageTitleWithSearch
          :title="'Projects'"
          :loading="loading"
          :search="search1"
          @searchText="searchChange1($event)"
        >
        </PageTitleWithSearch>
        <v-data-table
          v-if="projects"
          :headers="formattedHeadersPresen"
          :items="projects"
          :items-per-page="5"
          :hide-default-footer="true"
          :disable-sort="true"
          :disable-pagination="true"
          id="data-table"
        >
          <template v-slot:item="{ item, index }">
            <tr
              :class="[
                { 'first-row': index === 0 },
                index % 2 === 0 ? 'dark-row' : 'light-row',
                'custom-row',
              ]"
            >
              <td>{{ item.project_name }}</td>
              <td v-if="item.project_type" class="text-center">
                {{ item.project_type.name }}
              </td>
              <td v-else class="text-center">{{ "" }}</td>
              <td class="text-center">{{ item.bsa }}</td>
              <td class="text-center">{{ item.budget }}</td>
              <td class="text-center">{{ item.start_date }}</td>
              <td class="text-center">{{ item.estimated_hours }}</td>
              <td class="text-center">{{ item.actual_hours }}</td>
              <td class="text-center">{{ item.due_date }}</td>
              <td class="text-center">{{ item.customer.full_name }}</td>
              <td class="text-center">{{ item.status }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <Pagination
        @previous="page--"
        @next="page++"
        :loading="loading"
        :total="total"
        :page="page"
        class="mt-5"
      ></Pagination>
    </v-card>

    <ConfirmModal
      :text="'Do you want to drop this employer?'"
      :title="'Drop Employer'"
      :color="'red'"
      :confirmOpen="confirmOpen"
      @cancelConfirm="cancelConfirm()"
      @confirm="confirm()"
    ></ConfirmModal>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'warning'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

import DatePicker from "@/components/shared/DatePicker";
import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import ConfirmModal from "@/components/shared/ConfirmModal";
import Pagination from "@/components/shared/Pagination";
import Snackbars from "@/components/shared/Snackbars";
import { ReportService } from "@/services/report-service.js";
import { checkError } from "@/config/errors.js";
import Alert from "@/components/shared/Alert";
import TimeFrameButtons from "@/components/dashboard/TimeFrameButtons.vue";
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers("settings");

export default {
  name: "CustomerGrid",
  components: {
    Pagination,
    ConfirmModal,
    Snackbars,
    DatePicker,
    Alert,
    TimeFrameButtons,
    PageTitleWithSearch,
  },
  data: function() {
    return {
      employers: [],
      completed_projects: [],
      projects: [],
      activePeriod: "resource utilization table",
      page: 1,
      currentDate: new Date().toISOString().substr(0, 10),
      nextDate: this.getFutureDate(),
      errors: null,
      search: "",
      search1: "",
      form: {
        start_date: "",
        due_date: "",
      },
      loading: false,
      utili: true,
      past: false,
      presen: false,
      role: localStorage.getItem("role") || null,
      total: 0,
      totalProject: 0,
      dropId: null,
      confirmOpen: false,
      snackbar: false,
      successMsg: "This client has incomplete jobs. Can not delete",
      defaultImage: require("@/assets/img/avatar.svg"),
      headers: [
        { text: "", value: "emp_no", align: "left" },
        { text: "Name", value: "full_name", align: "center" },
        { text: "Specialty", value: "suburb", align: "center" },
        { text: "Allocated Hours", value: "suburb", align: "center" },
        { text: "Completed Hours", value: "suburb", align: "center" },
        { text: "Due Hours", value: "suburb", align: "center" },
        { text: "Working Hours", value: "suburb", align: "center" },
        { text: "Availability", value: "email", align: "center" },
      ],

      headersPast: [
        { text: "Project Name", value: "emp_no", align: "left" },
        { text: "Project Type", value: "full_name", align: "center" },
        { text: "Built in area", value: "suburb", align: "center" },
        { text: "Budget", value: "email", align: "center" },
        { text: "Start Date", value: "email", align: "center" },
        { text: "Estimated hours", value: "email", align: "center" },
        { text: "Actual hours", value: "email", align: "center" },
        { text: "End Date", value: "email", align: "center" },
        { text: "Completed Date", value: "email", align: "center" },
      ],

      headersPresen: [
        { text: "Project Name", value: "emp_no", align: "left" },
        { text: "Project Type", value: "full_name", align: "center" },
        { text: "Built in area", value: "suburb", align: "center" },
        { text: "Budget", value: "email", align: "center" },
        { text: "Start Date", value: "email", align: "center" },
        { text: "Estimated hours", value: "email", align: "center" },
        { text: "Actual hours", value: "email", align: "center" },
        { text: "End Date", value: "email", align: "center" },
        { text: "Client Name", value: "email", align: "center" },
        { text: "Status", value: "email", align: "center" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      profile: "profile",
    }),
    ...mapSettingsGetters({
      currencyCode: "currencyCode",
    }),
    formattedHeadersPast() {
      return this.headersPast.map((header) => {
        if (header.text.includes("Budget")) {
          return {
            ...header,
            text: header.text.replace("Budget",`Budget (${this.currencyCode})`),
          };
        }
        return header;
      });
    },
    formattedHeadersPresen() {
      return this.headersPresen.map((header) => {
        if (header.text.includes("Budget")) {
          return {
            ...header,
            text: header.text.replace("Budget", `Budget (${this.currencyCode})`),
          };
        }
        return header;
      });
    },
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.filterData(this.activePeriod);
    this.getCompletedProjectReport();
    this.getProjectReport();
    this.defaultList();
  },

  watch: {
    search() {
      this.page = 1;
      this.getCompletedProjectReport();
    },
    search1() {
      this.page = 1;
      this.getProjectReport();
    },
    page() {
      this.getCompletedProjectReport();
      this.getProjectReport();
    },
  },

  methods: {
    submit() {
      this.loading = true;

      let fd = new FormData();

      fd.append("start_date", this.form.start_date || "");
      fd.append("due_date", this.form.due_date || "");

      ReportService.getUserAvailability(fd)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.employers = response.data.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.employers = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    getFutureDate() {
      const date = new Date();
      date.setDate(date.getDate() + 7);
      return date.toISOString().substr(0, 10);
    },

    defaultList() {
      this.loading = true;

      let fd = new FormData();

      this.form.start_date = this.currentDate;
      this.form.due_date = this.nextDate;
      fd.append("start_date", this.form.start_date || "");
      fd.append("due_date", this.form.due_date || "");

      ReportService.getUserAvailability(fd)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.employers = response.data.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.employers = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    getCompletedProjectReport() {
      this.loading = true;
      ReportService.getCompletedProjectReport(this.search, this.page)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.completed_projects = response.data.data;
            this.total = response.data.meta.last_page || 0;
            this.totalProject = response.data.meta.total || 0;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.projects = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    getProjectReport() {
      this.loading = true;
      ReportService.getProjectReport(this.search1, this.page)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.projects = response.data.data;
            this.total = response.data.meta.last_page || 0;
            this.totalProject = response.data.meta.total || 0;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.projects = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    stringFormatting(str) {
      return str.replace(/_/g, " ");
    },

    filterData(timeFrame) {
      this.activePeriod = timeFrame;
      if (this.activePeriod == "resource utilization table") {
        this.utili = true;
        this.past = false;
        this.presen = false;
      } else if (this.activePeriod == "past projects performance") {
        this.utili = false;
        this.past = true;
        this.presen = false;
      } else {
        this.utili = false;
        this.past = false;
        this.presen = true;
      }
    },

    getChipColor(freeDays) {
      if (freeDays >= 75) {
        return "green";
      } else if (freeDays >= 50) {
        return "yellow";
      } else if (freeDays >= 25) {
        return "orange";
      } else {
        return "red";
      }
    },
    getStatusColor(status) {
      let bgColor = "";

      switch (true) {
        case status === "ACTIVE":
          bgColor = "#A5D6A7";
          break;
        default:
          bgColor = "#EF9A9A";
          break;
      }

      return bgColor;
    },

    searchChange(value) {
      this.search = value;
    },

    searchChange1(value) {
      this.search1 = value;
    },

    canCreateEdit() {
      if (
        this.role === "ADMINISTRATOR" ||
        this.role === "MANAGER" ||
        this.role === "USER"
      ) {
        return true;
      } else {
        return false;
      }
    },

    dropMemberConfirm(uuid) {
      this.dropId = uuid;
      this.confirmOpen = true;
    },

    cancelConfirm() {
      this.confirmOpen = false;
    },

    confirm() {
      this.confirmOpen = false;
      this.dropMember();
    },
    canDrop() {
      if (this.role === "ADMINISTRATOR") {
        return true;
      } else {
        return false;
      }
    },

    closeSnackbar() {
      this.snackbar = false;
    },
  },
};
</script>
<style>
.my-card3 {
  padding-top: 2%;
  padding-left: 2%;
  padding-right: 2%;
  margin-bottom: 2%;
}
</style>
